export enum Comparator {
  NONE = 'none',
  EQUAL = 'eq',
  BETWEEN = 'bw',
  NOT_EQUAL = 'ne',
  LESS_OR_EQUAL = 'le',
  LESS_THAN = 'lt',
  GREATER_OR_EQUAL = 'ge',
  GREATER_THAN = 'gt',
}
